import { render, staticRenderFns } from "./LefebvreFooterComponent.vue?vue&type=template&id=cc170782&scoped=true"
import script from "./LefebvreFooterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LefebvreFooterComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LefebvreFooterComponent.vue?vue&type=style&index=0&id=cc170782&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc170782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc170782')) {
      api.createRecord('cc170782', component.options)
    } else {
      api.reload('cc170782', component.options)
    }
    module.hot.accept("./LefebvreFooterComponent.vue?vue&type=template&id=cc170782&scoped=true", function () {
      api.rerender('cc170782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer/LefebvreFooterComponent.vue"
export default component.exports